import { useNavigate } from 'react-router-dom'

import { Popover, Icon, ButtonV2, LoaderV2, Tag } from 'components'

import {
  SERVICE_ORDER_TYPE_EN_PT,
  useGetServiceOrderDetails,
} from 'services/serviceOrder'

import { handleStatusLabel } from 'domains/serviceOrders/utilities'
import { handleRenderState } from 'utilities/handleRenderState'
import { buildPath, paths } from 'routes'

import styles from './styles.module.scss'

interface RichTooltipProps {
  serviceOrderId: string
}

const RichTooltip = ({ serviceOrderId }: RichTooltipProps) => {
  const navigate = useNavigate()
  const { data, isLoading, isError } = useGetServiceOrderDetails(serviceOrderId)

  const address = data?.patrimony?.address

  return (
    <div
      className={[styles.container, styles[data?.status || 'SCHEDULED']].join(
        ' ',
      )}
    >
      <Popover.Close>
        <Icon name="close-xlg" color="element-default" />
      </Popover.Close>
      {
        {
          view: !!data && (
            <>
              <section>
                <div>
                  <div className={styles.principalTag}>
                    {handleStatusLabel(data.status)}
                  </div>
                  <div>{data.number}</div>
                </div>
                <span>{data.account?.aggregatedName}</span>
              </section>
              <div className={styles.scroll}>
                <section>
                  <div>
                    <h4>Motivo</h4>
                    <span>{data.reason || '-'}</span>
                  </div>
                  <div>
                    <h4>Tipo</h4>
                    <span>
                      {SERVICE_ORDER_TYPE_EN_PT[data.serviceOrderType] || '-'}
                    </span>
                  </div>
                  <div>
                    <h4>Endereço</h4>
                    <span>
                      {address
                        ? `${address.address}, ${address.number} - ${address.district}, ${address.city}, ${address.acronym}`
                        : '-'}
                    </span>
                  </div>
                  <div>
                    <h4>Complemento</h4>
                    <span>{data.note || '-'}</span>
                  </div>
                  <div>
                    <h4>Tags da conta</h4>
                    <div className={styles.tags}>
                      {data.tags?.map((tag) => (
                        <Tag key={tag.id}>{tag.name}</Tag>
                      )) || '-'}
                    </div>
                  </div>
                </section>
              </div>
              <section>
                <ButtonV2
                  appearance="tertiary"
                  onClick={() =>
                    navigate(
                      buildPath({
                        path: paths.serviceOrder.details,
                        params: { serviceOrderId: data.id },
                      }),
                    )
                  }
                  className={styles.iconButton}
                >
                  <Icon name="open" />
                  Ver mais
                </ButtonV2>
              </section>
            </>
          ),
          loading: <LoaderV2 />,
          error: (
            <span className={styles.error}>
              Erro ao carregar detalhes da ordem de serviço. Tente novamente.
            </span>
          ),
        }[handleRenderState({ data, isError, isLoading })]
      }
    </div>
  )
}

export default RichTooltip
